import { Button, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProgramService from "../../../services/programs/program-service";

interface DuplicateProgramDialogProps {
    program: any
    onClose: any
};

const formInitialValue = {
    newCode: '',
};

const DuplicateProgramDialog: FC<DuplicateProgramDialogProps> = ({ program, onClose }) => {
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleFormSubmit = (values: any) => {
        setIsSubmiting(true);
        ProgramService.Copy(program.id, values.newCode).then((res: any) => {
            navigate(`/programs/${res.result.id}/edit`);
            //onRefreshData(res.result);
        }).finally(() => {
            setIsSubmiting(false);
        })
    };

    const formValidation = (values: any) => {
        //if (values.screenshot == null)
        //    return { screenshot: 'Silahkan upload bukti transfer' };
    };

    return (
        <Modal isOpen={true} onClose={onClose} >
            <ModalOverlay />
            <ModalContent>
                {
                    isLoading && "Loading..."
                }
                {
                    !isLoading &&
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit} validate={formValidation}>
                        {
                            ({ handleSubmit, errors, touched, setFieldValue }) => (
                                <Form onSubmit={handleSubmit} noValidate={true}>
                                    <ModalHeader textAlign={"center"}>Duplikasi Program</ModalHeader>
                                    <ModalBody pt={5}>

                                        <FormControl isRequired isInvalid={!!(errors.newCode && touched.newCode)} mt={4}>
                                            <FormLabel htmlFor='newCode'>Kode Program Baru</FormLabel>
                                            <Field
                                                as={Input}
                                                id='newCode'
                                                placeholder='Kode Program Baru'
                                                name={'newCode'}
                                                validate={(value: any) => {
                                                    let error;
                                                    if (value.length <= 0)
                                                        error = "Kode Program wajib diisi.";
                                                    return error;
                                                }}
                                            />
                                            <FormErrorMessage>{errors.newCode}</FormErrorMessage>
                                        </FormControl>

                                    </ModalBody>
                                    <ModalFooter>
                                        <Button variant={'outline'} mr={3} onClick={onClose}>
                                            Close
                                        </Button>
                                        <Button type={'submit'} isLoading={isSubmiting}>Duplikasi Sekarang</Button>
                                    </ModalFooter>
                                </Form>
                            )
                        }
                    </Formik>
                }
            </ModalContent>
        </Modal>
    );
};

export default DuplicateProgramDialog;
